import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import { src } from 'utils/imgix';

const stylesMap = {
  horizontal: require(`./ContentBlocks-horizontal.css`),
  stacked: require(`./ContentBlocks-stacked.css`),
};
let styles = {};

class ContentBlocks extends React.Component {
  constructor(props) {
    super(props);
    styles = stylesMap[props.layout];
  }

  componentWillUpdate() {
    styles = stylesMap[this.props.layout];
  }

  getImagePath(imagePath) {
    const isSvg = !!imagePath.match(`.svg`);
    if (isSvg) {
      return `/assets-spa/images/${imagePath}`;
    }

    return src(imagePath, 300);
  }

  renderImageTag(block) {
    const imageClass = classNames(styles[`image`], {
      [this.props.imageStyles]: this.props.imageStyles,
    });

    return (
      <img
        alt={block.imageAlt}
        className={imageClass}
        src={this.getImagePath(block.imagePath)}
      />
    );
  }

  renderImage(block) {
    if (!block.mobileImagePath) {
      return this.renderImageTag(block);
    }

    return (
      <picture>
        <source
          media="(max-width: 559px)"
          sizes="100vw"
          srcSet={this.getImagePath(block.mobileImagePath)}
        />
        <source
          media="(min-width: 560px)"
          sizes="100vw"
          srcSet={this.getImagePath(block.imagePath)}
        />
        {this.renderImageTag(block)}
      </picture>
    );
  }

  renderBlocks() {
    const blockClass = classNames(styles[`block`], {
      [this.props.blockStyles]: this.props.blockStyles,
    });

    const imageContainerClass = classNames(styles[`image-container`], {
      [this.props.imageContainerStyles]: this.props.imageContainerStyles,
    });

    const headingClass = classNames(styles[`heading`], {
      [this.props.headerStyles]: this.props.headerStyles,
    });

    const contentClass = classNames(styles[`content`], {
      [this.props.contentStyles]: this.props.contentStyles,
    });

    return this.props.blocks.map((block, i) => {
      return (
        <div
          className={blockClass}
          key={i}
        >
          <div className={imageContainerClass}>
            {this.renderImage(block)}
          </div>
          <div className={contentClass}>
            <div>
              <h3 className={headingClass}>{block.heading}</h3>
              <p className={styles[`paragraph`]}>{block.content}</p>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const containerClass = classNames(styles[`container`], {
      [this.props.containerStyles]: this.props.containerStyles,
    });

    return (
      <div className={containerClass}>
        {this.renderBlocks()}
      </div>
    );
  }
}

ContentBlocks.defaultProps = {
  layout: `horizontal`,
};

const blockShape = PropTypes.shape({
  heading: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  imagePath: PropTypes.string,
  imageAlt: PropTypes.string,
  mobileImagePath: PropTypes.string,
});

ContentBlocks.propTypes = {
  blockStyles: PropTypes.string,
  blocks: PropTypes.arrayOf(blockShape).isRequired,
  headingStyles: PropTypes.string,
  imageContainerStyles: PropTypes.string,
  imageStyles: PropTypes.string,
  layout: PropTypes.oneOf([
    `horizontal`,
    `stacked`,
  ]),
};

export default ContentBlocks;
